import React from "react";
import { BsLinkedin, BsTwitterX } from "react-icons/bs";
import { PiCopyright } from "react-icons/pi";
import { useLanguage } from "../Translations/LenguageContext";

const Footer = () => {
    const year = new Date().getFullYear();
    const { t, changeLanguage, language } = useLanguage()

    const handleLanguageChange = (event) => {
        changeLanguage(event.target.value);
    };
    return (
        <div className="footer_web">
            <div className="end_footer_item">
                <p><PiCopyright /> {year} Type Zero Research</p>
                <p>All rights reserved.</p>
                <div className="end_footer_socials">
                    {/* <a href="https://www.linkedin.com/company/erioon" target="_blank" rel="noopener noreferrer">
                            <i><BsLinkedin /></i>
                        </a>
                          <a href="https://x.com/ErioonLabs" target="_blank" rel="noopener noreferrer">
                            <i><BsTwitterX /></i>
                        </a> */}
                    <div className="change_language_cont">
                        <select className="language_select" onChange={handleLanguageChange} value={language}>
                            <option value="de">Deutsch</option>
                            <option value="en">English</option>
                            <option value="es">Español</option>
                            <option value="fr">Français</option>
                            <option value="it">Italiano</option>
                            <option value="no">Norsk</option>
                            <option value="sv">Svenska</option>
                        </select>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default Footer